import * as Api from './api/types';
import * as App from './app/types';

const wix = {
  Api: Api,
  App: App,
};

export { wix };
